const ID = 'accordion';

export default ID;
